var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDayStreak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.7616V8.3831C0 7.61976 0.959656 7.28061 1.43929 7.87444L7.71703 15.6469C8.08519 16.1027 8.80065 16.0285 9.06749 15.5069L16.2793 1.40863C16.58 0.820822 17.42 0.820821 17.7207 1.40863L24.9325 15.5069C25.1994 16.0285 25.9148 16.1027 26.283 15.6469L32.5607 7.87444C33.0403 7.28061 34 7.61976 34 8.3831V30.7616C34 31.2087 33.6376 31.5712 33.1905 31.5712H0.809524C0.362436 31.5712 0 31.2087 0 30.7616Z",
    fill: "#FFCA23"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayStreak);
export default __webpack_public_path__ + "static/media/day-streak.55ff8c6009d3cb22a267e98f30bb1761.svg";
export { ForwardRef as ReactComponent };